/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./pageFrens.vue?vue&type=template&id=169b5b86&scoped=true"
import script from "./pageFrens.vue?vue&type=script&lang=js"
export * from "./pageFrens.vue?vue&type=script&lang=js"
import style0 from "./pageFrens.vue?vue&type=style&index=0&id=169b5b86&prod&lang=scss"
import style1 from "./pageFrens.vue?vue&type=style&index=1&id=169b5b86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "169b5b86",
  null
  
)

export default component.exports